import React, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid, Typography,Dialog, alpha, Stack,  } from '@mui/material';
import Headervideo from '../../../assets/Headervideo.mp4';
import LockerMenu from '../../Components/LockerMenu';
import Paragraph from '../../Components/LockerMenu/component/Paragraph';
import Heading from '../../Components/LockerMenu/component/Heading';
import CustomButton from '../../Components/LockerMenu/component/Button';
import icon from '../../../assets/Icon.svg';
import { IoSearchOutline } from 'react-icons/io5';
// mui

import IconButton from '@mui/material/IconButton';
import Search from '../../Components/LockerMenu/component/Search/search';

const Wrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }
`;

const Main = styled(Grid)`
  padding: 120px 0px;
`;

const BlurOverlay = styled(Box)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 25%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 7%,
    rgba(255, 255, 255, 0.7) 41%,
    rgba(255, 255, 255, 0.85) 64%,
    rgba(255, 255, 255, 0.95) 76%,
    #ffffff 100%
  );
  z-index: 1;
`;

const ButtonContainer = styled(Box)`
  position: absolute;
  bottom: 20px; 
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  gap: 10px; 
`;

const SearchIcon = styled('img')`
  width: 18px;
  height: 18px;
  margin-right: 10px; 
`;

const StyledButton = styled(CustomButton)`
  display: flex;
  align-items: center;
  border-radius: 30px;
  padding: 15px 20px;
  @media (max-width: 600px) {
    padding: 15px 15px;
  }
  @media (max-width: 400px) {
    padding: 15px 15px;
    font-size: 12px;
  }
`;

const StyledButtonWithInput = styled(StyledButton)`
  padding: 20px 10px 20px 15px;
`;

const SearchInput = styled('input')`
  background: transparent;
  border: none;
  outline: none;
  color: inherit;
  font-family: inherit;
  font-size: ${({ theme }) => theme.typography?.body1?.fontSize || '16px'};
  padding: 0;
  width: 180px;

  &::placeholder {
    color: inherit;
    opacity: 0.7;
  }

  @media (max-width: 600px) {
    width: 140px;
    font-size: 14px;
  }

  @media (max-width: 400px) {
    width: 115px;
    font-size: 12px;
  }
`;

const Header = () => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);


  useEffect(() => {
    const playVideo = () => {
      if (videoRef.current) {
        videoRef.current.play().then(() => {
          setIsPlaying(true);
        }).catch((error) => {
          console.log('Error while playing video:', error);
        });
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        videoRef.current.pause(); 
      } else {
        setTimeout(() => {
          playVideo(); 
        }, 300);
      }
    };


    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (!document.hidden) {
      playVideo();
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);


  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch((error) => {
        console.log('Error playing video:', error);
      });
    }
  };

  return (
    <Wrapper>
      <video ref={videoRef} loop muted playsInline>
        <source src={Headervideo} type="video/mp4"/>
        Your browser does not support the video tag.
      </video>

      {!isPlaying && (
        <ButtonContainer>
          <StyledButton onClick={handlePlay}>
            <SearchIcon src={icon} alt="search icon" />
            Play Video
          </StyledButton>
        </ButtonContainer>
      )}

      <LockerMenu />
      <Container>
        <Grid container xs={12} md={6}>
          <Main item>
            <Heading style={{ marginBottom: '10px', lineHeight: '100%', alignItems: 'center' }}>
              The Smarter,<br /> AI-Powered Decentralized Marketplace
            </Heading>
            <Paragraph style={{ maxWidth: '380px', lineHeight: '150%', marginBottom: '10px', opacity: '0.7' }}>
              Harness the power of decentralized AI marketplace with AICM.
            </Paragraph>
          </Main>
        </Grid>
      </Container>

      <ButtonContainer   onClick={handleClickOpen}>
        <StyledButtonWithInput onClick={handleClickOpen}>
          <SearchIcon src={icon} alt="search icon"  />
          <SearchInput placeholder="Search with AICM"style={{cursor:'pointer'}} />
       
        </StyledButtonWithInput>
      </ButtonContainer>
      <Dialog open={open} onClose={handleClose} sx={{ '& .MuiPaper-root': { width: 600,borderRadius:'20px' } }}>
        <Search onClose={handleClose} />
      </Dialog>
     
      <BlurOverlay />
    </Wrapper>
  );
};

export default Header;
